import React from 'react';
import PropTypes from 'prop-types';
import Button from 'widgets/Button';

function OutOfStock({ hasAlternatives, onSeeAlternativesClick, deranged }) {
  return (
    <div className="bop-outOfStock">
      <h2>{deranged ? 'No longer stocked' : 'Out of stock'}</h2>
      <p className="bop-outOfStock__text">
        {deranged ?
          'We no longer stock this item.'
          : 'This product is not available. Please check back soon for more info.'
        }
      </p>

      { hasAlternatives && !deranged && (
        <Button
          className="bop-outOfStock__button"
          size="large"
          onClick={onSeeAlternativesClick}
          primary
        >
          See alternatives
        </Button>) }
    </div>
  );
}

OutOfStock.propTypes = {
  hasAlternatives: PropTypes.bool.isRequired,
  onSeeAlternativesClick: PropTypes.func.isRequired,
  deranged: PropTypes.bool,
};

export default OutOfStock;
